(function () {

  var quotifyPopupTimeout = null
  const initAnchorLinks = function () {
    const updateScrollOffset = function () {
      window.SCROLL_OFFSET = $("header").outerHeight() + 15
    }
    $(window).on("resize", updateScrollOffset)
    updateScrollOffset();
    $.fn.scrollToMe = function(cb, duration, opts) {
        duration = duration || 400
        opts = opts || {}
        var $elm = this
        if (!$elm.length) { return $elm }
        var elementTop = 0
        do {
            elementTop = $elm.offset().top
            $elm = $elm.parent()
            if (!$elm.length) {
                break;
            }
        } while (!elementTop)if (!elementTop) {
            setTimeout(cb, 0)
            return this
        }
        jQuery("html,body").animate({
            scrollTop: elementTop - window.SCROLL_OFFSET
        }, duration, cb);
        return this;
    }
    
    $(document).on("click", "a[href^='#']", function () {
      $($(this).attr("href")).scrollToMe();
      return false
    })
    
    if (window.location.hash) {
      var $quotifyBtn = $("button[data-quotify]")
      if (window.location.hash === "#submit-design" && $quotifyBtn.length) {
        
        quotifyPopupTimeout = setTimeout(function () {
          location.reload()
        }, 7000)
        const $overlay = $(".full-screen-spinner")
        
        $quotifyBtn.on("quotifyBtn:enable", function () {
        	$overlay.fadeOut()
            clearTimeout(quotifyPopupTimeout)
        })
        setTimeout(function () {
        	$quotifyBtn.get(0).click()
        }, 500);
      } else {
        $(window.location.hash).scrollToMe()
      }
      
    }
  }
  
  const initQuotifyButton = function () {
    // Quotify Button loading spinner
    var $customizeDesignBtn = $(".quotify-request-quote-btn");

    $customizeDesignBtn.on("quotifyBtn:disable", function () {
      $customizeDesignBtn.attr("disabled", "disabled").addClass("quotify-btn-loading")
    }).on("quotifyBtn:enable", function () {
      $customizeDesignBtn.removeAttr("disabled").removeClass("quotify-btn-loading")
    })

    $customizeDesignBtn.on("click", function () {
        $customizeDesignBtn.trigger("quotifyBtn:disable")
        var checkIframeLoadInterval = setInterval(function () {
           if ($("#quotify-frame").is(":visible")) {
               setTimeout(function () {
                   $customizeDesignBtn.trigger("quotifyBtn:enable")
                   
               }, 1000)
               clearInterval(checkIframeLoadInterval)
           }
        }, 300)
    })
  }
  
  const initCustomHandlers = function () {
    if (/^\/collections\/design\-library\/products\/?/.test(location.pathname)) {
      $(".product-section--title.product-recommendations--title").text("More Designs")
      if (/^\/collections\/design\-library\/products\/([a-z]|[0-9])/.test(location.pathname)) {
        $("a.shipping-policy-product-link").hide()
        $(".product-form--atc").hide()
        $(".product-form--regular").before($(".product-description"))   
      }
    }
    if (/^\/collections\/design\-library\/?/.test(location.pathname)) {
      
      var imageLink = ""; //"https://domain.com"
      var imageUrl = "//cdn.shopify.com/s/files/1/0565/8604/3550/files/design_gallery_banner.png?v=1624450823" //"//cdn.shopify.com/s/files/1/0565/8604/3550/collections/Alpha_Phi-Website_-_mobile_1350x754.jpg?v=1623052337"
      
      if (imageUrl) {
        var $img = $("<img>", {
          class: "collection-top-image",
          src: imageUrl
        }).css("width", "100%")

        $(".productgrid--masthead").prepend(
          imageLink ? $("<a>", {
            href: imageLink
          }).append($img) : $img
        )
      }
    }
  }
  
  const initProductHandlers = function (activeFilters) {
/*    var $vendorLink = $(".wk_seller_detail.product-vendor a")
    if ($vendorLink.text()) {
      $(".breadcrumbs-container span:last")
      .before([
        $vendorLink.clone(),
        $(".breadcrumbs-delimiter").clone()
      ])
      clearInterval(vendorLinkInterval)
    }*/
  }
  
  const initLandingPages = function () {
    
      const TYPEWRITERS = {
        // Homepage
//         "h2.slideshow-slide__heading": [function ($el) {
//         	$el.html('<span class="typewriter-top-heading-text">Design</span>custom printed apparel')
//         }, function (tw) {
//           tw.typeString('Design')
//             .pauseFor(900)
//             .deleteAll()
//             .typeString('Order')
//             .pauseFor(900)
//             .deleteAll()
//             .typeString('Sell')
//             .pauseFor(900)
//             .start();
//         }],
        
           // bulk landing page
        ".bulk-animated-heading h1": [function ($el) {
        	$el.html('The best place to order your<br><span class="typewriter-top-heading-text">business</span>apparel.')
        }, function (tw) {
          tw.typeString('business')
            .pauseFor(600)
            .deleteAll()
            .typeString('school')
            .pauseFor(600)
            .deleteAll()
            .typeString('nonprofit')
            .pauseFor(600)
          	.deleteAll()
            .typeString('camp')
            .pauseFor(600)
          	.deleteAll()
            .typeString('band')
            .pauseFor(600)
          	.deleteAll()
            .typeString('family')
            .pauseFor(600)
          	.deleteAll()
            .typeString('fun')
            .pauseFor(600)
            .start();
        }],
        
               // bulk landing page
        ".store-animated-heading h1": [function ($el) {
        	$el.html('Open an online store for your<br><span class="typewriter-top-heading-text">organization.</span>')
        }, function (tw) {
          tw.typeString('organization.')
            .pauseFor(600)
            .deleteAll()
            .typeString('business.')
            .pauseFor(600)
            .deleteAll()
            .typeString('nonprofit.')
            .pauseFor(600)
          	.deleteAll()
            .typeString('college club.')
            .pauseFor(600)
          	.deleteAll()
            .typeString('merch line.')
            .pauseFor(600)
            .start();
        }],
        
        // start form Landing page
        ".landing-animated-heading h1": [function ($el) {
        	$el.html('Your all in one solution for<br><span class="typewriter-top-heading-text">bulk orders.</span>')
        }, function (tw) {
          tw.typeString('bulk orders.')
            .pauseFor(500)
            .deleteAll()
            .typeString('campaigns.')
            .pauseFor(500)
            .deleteAll()
            .typeString('free storefronts.')
            .pauseFor(500)
            .start();
        }]
      }
    
    
      var foundTypewriterElms = Object.keys(TYPEWRITERS).map(function (sel) {
        return {
          $el: $(sel),
          selector: sel,
          fn: TYPEWRITERS[sel]
        }
      }).filter(function (el) {
      	return el.$el.length
      })
     
    if (foundTypewriterElms.length) {      
      $.getScript("https://cdnjs.cloudflare.com/ajax/libs/TypewriterJS/2.18.0/core.min.js", function() {
        foundTypewriterElms.forEach(function (cEl) {
          cEl.fn[0](cEl.$el)
          
          var twEl = document.querySelector('.typewriter-top-heading-text');

          var typewriter = new Typewriter(twEl, {
            loop: true
          });

          cEl.fn[1](typewriter)
        })
        
      })
    }
  }

  window.SellerProfileProductsRendered = function () {
  	$("div[data-product-type]").sort(function (a, b) {
     const productTypes = ["Campaign", "Retail"]
     return productTypes.indexOf(a.dataset.productType) < productTypes.indexOf(b.dataset.productType) ? -1 : 1
    }).appendTo(".seller_product_grid")

    var lastProductType = ""
    $("div[data-product-type]").each(function () {
      var $this = $(this)
      var headingTexts = {
        Campaign: "Live Campaigns",
        Retail: "Retail Products"
      }
      var cProductType = $this.attr("data-product-type")
      if (lastProductType !== cProductType) {
         var $heading = $("<h3>", { class: "col-xs-12 seller-profile-products-heading", text: headingTexts[cProductType] || cProductType })
         $this.before($heading)
         lastProductType = cProductType
      }
    })
  }
  

  // Handlers depending on SPL (WebKul) and jQuery
  const checkSPLInterval = setInterval(function () {
    if (typeof SPL !== "undefined" && typeof $ !== "undefined") {
    	clearInterval(checkSPLInterval)
        // ...
    }
  }, 100)
  
  const initDesignTemplateHandlers = function () {
    if (meta.product.type !== "Design Template") { return; }
    $("[data-product-details]").after($("[data-product-description]"))
  }
  
  // Handlers depending only on jQuery
  const checkJQueryInterval = setInterval(function () {
    if (typeof $ !== "undefined") {
    	clearInterval(checkJQueryInterval)
        initQuotifyButton()
        initAnchorLinks()
        initCustomHandlers()
        initProductHandlers()
        initLandingPages()
        initDesignTemplateHandlers()
    }
  }, 100)
})()